// import { AxiosRequestConfig } from '@/public/fetch/type'
import { cryptoInstance } from '@/public/fetch/index';
import { indexApi2 } from '@/public/utils/basePath';
export const homeReq = {};
export const demo = (params) => {
    return cryptoInstance.get('/v2/index/0', {
        baseURL: indexApi2,
        params
    });
};
const baseURL = indexApi2;
/**
 * @params
 * userId
 * @query 添加获取病种等子类
 * labelId 亚专业 id
 * moduleId 类型 Id
 *
 */
export const getSubDep = ({ params, query }) => {
    // 获取亚专业列表
    return cryptoInstance.get(`/v5/labels/${params.userId}`, {
        baseURL: indexApi2,
        params: query
    });
};
export const getModules = (params) => {
    return cryptoInstance.get(`/v5/modules/${params.labelId}`, {
        baseURL: indexApi2
    });
};
// 获取omo 共学营 搜索关键字列表
export const getMoreList = (data, params) => {
    return cryptoInstance.get(`/v2/search/more_${data.type}_list/${data.userId}/${data.pageNo}`, {
        baseURL,
        params
    });
};
// 知识元和亚专业列表
export const getKnowledgeTree = (userId) => {
    return cryptoInstance.get(`/v5/subspecialtyKnowledgeElementTree/${userId}`, {
        baseURL
    });
};
// 获取科室会员、课程、亚专业列表
export const getCourseTabs = (userId, params) => {
    return cryptoInstance.get(`/v5/courseCenter/tab/${userId}`, {
        params,
        baseURL
    });
};
// 获取课程列表
export const getCourseList = (userId, params) => {
    return cryptoInstance.get(`/v5/courseCenter/list/${userId}`, {
        params,
        baseURL
    });
};
// 获取练页面中学习tab
export const getStudyTab = (userId, params) => {
    return cryptoInstance.get(`/v8/study/tab/${userId}`, { params, baseURL });
};
// 获取学习课程列表
export const getStudyCourseList = (userId, params) => {
    return cryptoInstance.get(`/v8/study/list/${userId}`, {
        baseURL,
        params
    });
};
// 获取banner图分享信息
export const bannerShareInfo = (bannerId) => {
    return cryptoInstance.get(`/v8/banner_share/${bannerId}`, { baseURL });
};
